import { handleActions } from 'redux-actions';
import { FREE_FORM_EDITOR_ID } from '../../const';

const initialState = {
  last_editor_data: '',
  last_language: '',
  chat_data: [],
  notes: [],
  current_page: '',
  problem_id: '',
  results: [],
  unreadCount: 0,
  theme: 'vs',
  isLoadingResults: false,
  customInputTracking: null,
  currentLanguageforProblems: [
    {
      problem_id: FREE_FORM_EDITOR_ID,
      language: 'python3',
      code: '#write code here',
    },
  ],
};

const EventReducer = handleActions(
  {
    SET_LAST_CODE: (state, action) => {
      const updatedLanguageForProblems = state.currentLanguageforProblems.map(problem => {
        if (problem.problem_id === action.payload.problem_id) {
          return { ...problem, code: action.payload.data };
        }
        return problem;
      });
      return {
        ...state,
        last_editor_data: action.payload.data,
        problem_id: action.payload.problem_id,
        currentLanguageforProblems: updatedLanguageForProblems,
      };
    },
    SET_LAST_LANGUAGE: (state, action) => {
      const updatedLanguageForProblems = state.currentLanguageforProblems.map(problem => {
        if (problem.problem_id === action.payload.problem_id) {
          return { ...problem, language: action.payload.language };
        }
        return problem;
      });
      return {
        ...state,
        last_language: action.payload.language,
        problem_id: action.payload.problem_id,
        currentLanguageforProblems: updatedLanguageForProblems,
      };
    },
    SET_CHAT_EVENTS: (state, action) => {
      return {
        ...state,
        chat_data: action.payload ? action.payload : '',
      };
    },
    GET_SUPPORTED_LANGUAGES: (state, action) => {
      return {
        ...state,
        supported_languages: action.payload,
      };
    },
    SET_INITIAL_NOTES: (state, action) => {
      return {
        ...state,
        notes: action.payload,
      };
    },
    SET_NOTES: (state, action) => {
      return {
        ...state,
        notes: [...state.notes, action.payload],
      };
    },
    UPDATE_NOTE: (state, action) => {
      let updated_notes = state.notes.map(obj => {
        if (obj.id === action.payload.id) {
          return {
            ...obj,
            data: action.payload.data,
          };
        }
        return obj;
      });
      return {
        ...state,
        notes: updated_notes,
      };
    },
    SET_END_INTERVIEW_USER_DETAIL: (state, action) => {
      return {
        ...state,
        end_interview_user_detail: action.payload,
      };
    },
    SET_CURRENT_PAGE: (state, action) => {
      return {
        ...state,
        current_page: action.payload,
      };
    },
    SET_HEARTBEAT: (state, action) => {
      return {
        ...state,
        heartbeat: action.payload,
      };
    },
    SET_RESULTS: (state, action) => {
      return {
        ...state,
        results: action.payload,
      };
    },
    SET_ACTIVE_TAB: (state, action) => {
      return {
        ...state,
        problem_id: action.payload,
      };
    },
    SET_UNREAD_COUNT: (state, action) => {
      const newCount =
        typeof action.payload === 'function' ? action.payload(state.unreadCount) : action.payload;
      return {
        ...state,
        unreadCount: newCount,
      };
    },
    SET_LOADING_RESULTS: (state, action) => {
      return {
        ...state,
        isLoadingResults: action.payload,
      };
    },
    SET_CUSTOM_INPUT_TRACKING: (state, action) => {
      return {
        ...state,
        customInputTracking: action.payload.type,
      };
    },
    CLEAR_CUSTOM_INPUT_TRACKING: (state, action) => {
      return {
        ...state,
        customInputTracking: null,
      };
    },
    SET_THEME: (state, action) => {
      return {
        ...state,
        theme: action.payload,
      };
    },
    SET_CURRENT_LANGUAGE_FOR_PROBLEMS: (state, action) => {
      const newItems = action.payload.filter(
        newItem =>
          !state.currentLanguageforProblems.some(
            existingItem => existingItem.problem_id === newItem.problem_id,
          ),
      );
      return {
        ...state,
        currentLanguageforProblems: [...state.currentLanguageforProblems, ...newItems],
      };
    },
    UPDATE_LANGUAGE_FOR_PROBLEM: (state, action) => {
      const { problem_id, language, code } = action.payload;
      const existingIndex = state.currentLanguageforProblems.findIndex(
        item => item.problem_id === problem_id,
      );
      if (existingIndex !== -1) {
        const updated = [...state.currentLanguageforProblems];
        updated[existingIndex] = { ...updated[existingIndex], language, code };
        return { ...state, currentLanguageforProblems: updated };
      } else {
        return {
          ...state,
          currentLanguageforProblems: [
            ...state.currentLanguageforProblems,
            { problem_id, language, code },
          ],
        };
      }
    },
    UPDATE_CODE_AND_LANGUAGE_FOR_PROBLEM: (state, action) => {
      const { problem_id, code, language } = action.payload;
      console.log(
        'Updating code and language for problem_id',
        problem_id,
        'to language',
        language,
        'and code',
        code,
      );
      const updatedLanguageForProblems = state.currentLanguageforProblems.map(problem => {
        console.log('Checking problem', problem.problem_id, 'against', problem_id);
        if (problem.problem_id === problem_id) {
          console.log('Id Match Found. Updating code and language for problem_id', {
            ...problem,
            code,
            language,
          });
          return { ...problem, code, language };
        }
        return { ...problem, code, language };
      });
      console.log('let se the state once', state);
      return {
        ...state,
        currentLanguageforProblems: updatedLanguageForProblems,
      };
    },
  },
  initialState,
);

export default EventReducer;
